"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactRolEchainsMock = void 0;
const KetteBauform_1 = require("../kette/KetteBauform");
const KetteSerieType_1 = require("../kette/KetteSerieType");
const fuehrungsrinne_typ_1 = require("../fuehrungsrinne/fuehrungsrinne-typ");
exports.compactRolEchainsMock = [
    {
        Id: 1,
        ArtNr: { DE: '2828R.06.220.S10.0.E' },
        ArtNrExists: true,
        ArticleType: 'rolEchain',
        Bauform: KetteBauform_1.KetteBauform.kette,
        FreigabeEIQ: true,
        FreigabeEKE: true,
        Innenhoehe_mm: 32,
        Innenbreite_mm: 68,
        Aussenhoehe_mm: 54,
        Aussenbreite_mm: 92,
        BeschleunigungGleitendMax_m_s2: 1000,
        GeschwindigkeitGleitendMax_m_s: 1000,
        MinBauraumGleitendRinneRefs: [
            {
                FuehrungsrinneId: 123,
                FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
                FuehrungsrinneStuecklaenge: { Value: 2000, Unit: 'mm' },
                FuehrungsrinneStuecklaenge_mm: 2000,
                MontageSetId: 456,
                Breite: { Value: 101, Unit: 'mm' },
                Breite_mm: 101,
                Hoehe: { Value: 301, Unit: 'mm' },
                Hoehe_mm: 301,
            },
        ],
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        SerieRef: {
            Id: 9180542665,
            Kuerzel: '2828R',
        },
        LeitungDiameterMax_mm: 28,
        Biegeradius_mm: 220,
        GleitenderBetriebErlaubt: true,
        K2_mm: 1624,
        D1_mm: 260,
        X1_mm: 780,
    },
    {
        Id: 2,
        ArtNr: { DE: '5050RHD.06.300.S10.0.E' },
        ArtNrExists: true,
        ArticleType: 'rolEchain',
        FreigabeEIQ: true,
        FreigabeEKE: true,
        Innenhoehe_mm: 80,
        Innenbreite_mm: 65,
        Aussenhoehe_mm: 108,
        Aussenbreite_mm: 125,
        BeschleunigungGleitendMax_m_s2: 1000,
        GeschwindigkeitGleitendMax_m_s: 1000,
        MinBauraumGleitendRinneRefs: [
            {
                FuehrungsrinneId: 123,
                FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
                FuehrungsrinneStuecklaenge: { Value: 2000, Unit: 'mm' },
                FuehrungsrinneStuecklaenge_mm: 2000,
                MontageSetId: 456,
                Breite: { Value: 101, Unit: 'mm' },
                Breite_mm: 101,
                Hoehe: { Value: 301, Unit: 'mm' },
                Hoehe_mm: 301,
            },
        ],
        Bauform: KetteBauform_1.KetteBauform.kette,
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        SerieRef: {
            Id: 9179764941,
            Kuerzel: '5050RHD',
        },
        LeitungDiameterMax_mm: 74,
        Biegeradius_mm: 200,
        GleitenderBetriebErlaubt: true,
        K2_mm: 2457,
        D1_mm: 400,
        X1_mm: 1170,
    },
];
//# sourceMappingURL=compactRolEchains.mock.js.map